import {apiClient} from 'common/util/api-client';
import {getReportUrl} from 'common/report/util';
import {
  PlatformApp as PlatformAppResult,
  Results as GetPlatformAppsResults,
} from 'app_api/projects/platform_apps/types';

// Partial<PlatformAppResult> because some platform apps are hard coded e.g segmentation and jql
export interface PlatformApp extends Partial<PlatformAppResult> {
  name: string;
  description: string;
  created_by?: string;
  url: string;
  gated?: boolean;
  hidden?: boolean;
}

export async function getPlatformApps({
  projectId,
  includeBuildCustomApp = false,
}: {
  projectId: number;
  includeBuildCustomApp?: boolean;
}): Promise<PlatformApp[]> {
  const platformAppsInfoUrl = `/api/app/projects/${projectId}/platform-apps`;
  const results = await apiClient.get<GetPlatformAppsResults>(platformAppsInfoUrl);

  const platformApps: PlatformApp[] = [
    includeBuildCustomApp
      ? {
          name: `Build a custom app`,
          description: `If you're a developer, utilize our powerful APIs to build applications that help you visualize your own data in unique ways.`,
          url: getReportUrl(`mpplatform/new/#choose_template`, {projectId}),
          gated: results.max_platform_apps_exceeded,
        }
      : null,
    ...results.platform_apps,
  ].filter(Boolean);
  return platformApps;
}
